import { List, Map } from 'immutable';

/**
 * Map stakes bets to component props.
 *
 * @param {object} state
 * @param {function} matches
 * @param {StakeEntity} stake
 * @param {{selectors: object}} staking
 * @return {{bets: Immutable.List<BetEntity>, fixedBets: object<number, boolean>, disabled: boolean }} component props
 */
export function mapBetsToStake(
  state,
  matches,
  stake,
  staking,
) {
  const fixedBets = process.env.SERVER ? Map() : staking.selectors.bets(state);

  const match = stake && matches(state).get(stake.matchId);

  const fixedBetsProps = {};

  const bets = match ? stake.bets.map((betId) => {
    const bet = match.bets.get(betId);

    fixedBetsProps[betId] = fixedBets.has(betId);
    return bet;
  }).toList() : List();

  return {
    bets,
    fixedBets: fixedBetsProps,
    disabled: !(stake && stake.isOpen && match && match.isOpen),
  };
}


// TODO: переписать на TS, плюс посмотреть, где используется, потому что там @ts-ignore стоит
// Плюс перенести в modules/Betting
/**
 * Compare stake props for `shouldComponentUpdate` function.
 *
 * @param {object} thisProps
 * @param {Immutable.List<BetEntity>} thisProps.bets
 * @param {boolean[]} thisProps.fixedBets
 * @param {object} nextProps
 * @param {Immutable.List<BetEntity>} nextProps.bets
 * @param {boolean[]} nextProps.fixedBets
 *
 * @param {boolean} thisProps.disabled
 * @param {boolean} nextProps.disabled
 *
 * @param {Set<number>} thisProps.conflictedIds
 * @param {Set<number>} nextProps.conflictedIds
 *
 * @param {function} thisProps.addBet
 * @param {function} nextProps.addBet
 *
 * @return {boolean}
 */
export function compareStakeProps(thisProps, nextProps) {
  const { fixedBets, disabled, conflictedIds, addBet } = thisProps;
  return !thisProps.bets?.equals(nextProps.bets)
    || (conflictedIds !== nextProps.conflictedIds)
    || (addBet !== nextProps.addBet)
    || (disabled !== nextProps.disabled)
    || Object.keys(fixedBets).some((key) => (fixedBets[key] !== nextProps.fixedBets[key]));
}
